import { Loader2Icon } from "lucide-react";
import { cn } from "@/lib/utils";

const sizeMap = {
  xs: "size-3",
  sm: "size-3.5",
  md: "size-4",
  lg: "size-8",
} as const;

type SpinnerSize = keyof typeof sizeMap;

export function Spinner({
  size = "xs",
  className,
}: {
  size?: SpinnerSize;
  className?: string;
}) {
  return <Loader2Icon className={cn(sizeMap[size], "animate-spin", className)} />;
}
